import { render } from "./PricingCard.vue?vue&type=template&id=12408f5b"
import script from "./PricingCard.vue?vue&type=script&lang=js"
export * from "./PricingCard.vue?vue&type=script&lang=js"

import "./PricingCard.vue?vue&type=style&index=0&id=12408f5b&lang=css"

import exportComponent from "D:\\projects\\email-blaster\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__